"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenewalPremiumTypeChangeModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var components_1 = require("@athena-portal/components");
var journey_services_1 = require("@ferry/journey-services");
var moment = require("moment/moment");
var reactstrap_1 = require("reactstrap");
var journey_model_1 = require("@athena-portal/journey-model");
var RenewalPremiumTypeChangeModal = /** @class */ (function (_super) {
    __extends(RenewalPremiumTypeChangeModal, _super);
    function RenewalPremiumTypeChangeModal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            popupOpen: true,
            isFromAgentPortal: _this.getSetting("isFromAgentPortal", false),
        };
        _this.closePopup = _this.closePopup.bind(_this);
        _this.cancelChanges = _this.cancelChanges.bind(_this);
        _this.updateRenewal = _this.updateRenewal.bind(_this);
        return _this;
    }
    RenewalPremiumTypeChangeModal.prototype.render = function () {
        var _a;
        var initialPaymentDate = this.props.interaction.renewalDetails.monthlyPayerInitialPaymentDate || this.props.interaction.renewalDetails.annualPayerInitialPaymentDate;
        var inGracePeriod = this.props.interaction.uistate.inGracePeriod;
        var isMonthly = ((_a = this.props.interaction.factors) === null || _a === void 0 ? void 0 : _a.premiumType) === journey_services_1.AnnualPolicyPremiumTypeEnum.MONTHLY;
        return ((0, jsx_runtime_1.jsxs)(components_1.Modal, { className: "my-2 info-modal", isOpen: this.state.popupOpen, toggle: this.closePopup, children: [(0, jsx_runtime_1.jsx)(components_1.ModalHeader, { toggle: this.closePopup, children: "You didn't save your changes" }), (0, jsx_runtime_1.jsxs)(components_1.ModalBody, { children: [!inGracePeriod && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", { children: ["Do you want to pay ", isMonthly ? "monthly" : "annually", " when your cover renews?"] }), (0, jsx_runtime_1.jsxs)("p", { children: ["No payment will be taken until ", moment.utc(initialPaymentDate, moment.ISO_8601).format("DD MMM YYYY"), "."] }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("p", { className: "font-weight-bold", children: "Save changes and setup policy to renew?" })] })), inGracePeriod && (0, jsx_runtime_1.jsx)("p", { children: "Did you want to save your changes?" })] }), (0, jsx_runtime_1.jsxs)(components_1.ModalFooter, { children: [(0, jsx_runtime_1.jsx)(reactstrap_1.Button, { className: "my-2 w-100 float-right", color: "btn btn-white", onClick: this.cancelChanges, children: "No, cancel changes" }), (0, jsx_runtime_1.jsx)(reactstrap_1.Button, { className: "my-2 px-4 w-100 float-right btn-link", color: "btn btn-primary btn-next-no-arrow", onClick: this.updateRenewal, children: inGracePeriod ? "Renew my policy" : "Save & update renewal" })] })] }));
    };
    RenewalPremiumTypeChangeModal.prototype.closePopup = function () {
        this.setState({ popupOpen: false });
        this.props.onStateChange("uistate.temp.cancelChangesPressed", false);
    };
    RenewalPremiumTypeChangeModal.prototype.cancelChanges = function () {
        this.closePopup();
        if (this.state.isFromAgentPortal) {
            window.location.href = "/customers/".concat(this.props.interaction.userReference);
        }
        else {
            window.location.href = "/dashboard/annualMotor/".concat(this.props.interaction.agreementNumber);
        }
    };
    RenewalPremiumTypeChangeModal.prototype.updateRenewal = function () {
        this.closePopup();
        this.executeEvent("change");
    };
    RenewalPremiumTypeChangeModal = __decorate([
        (0, journey_model_1.settings)([{ name: "isFromAgentPortal", type: journey_model_1.TypeDescriptions.Boolean }]),
        __metadata("design:paramtypes", [Object])
    ], RenewalPremiumTypeChangeModal);
    return RenewalPremiumTypeChangeModal;
}(plugin_journey_1.WidgetBase));
exports.RenewalPremiumTypeChangeModal = RenewalPremiumTypeChangeModal;
//# sourceMappingURL=RenewalPremiumTypeChangeModal.js.map